import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";
import * as XLSX from "xlsx";
import { getApiBaseUrl } from "../../utils/utils";
const BillingUpdate = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  // Handle the barcode scan (onChange or onKeyUp event)
  const handleBarcodeInputChange = (event) => {
    setBarcode(event.target.value);
  };

  const handleBarcodeKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevents form submission or unwanted behavior
      const scannedValue = barcode.trim();

      if (scannedValue) {
        processBarcode(scannedValue);
        setTimeout(() => setBarcode(""), 100); // Allow time for barcode to register
      }
    }
  };

  const processBarcode = (scannedValue) => {
    const scannedBarcodes = scannedValue
      .split(/[\n,]+/)
      .map((value) => value.trim()) // ✅ Trim each value first
      .filter((value) => value !== "") // ✅ Remove any empty strings
      .map((value) => {
        if (value.startsWith("E") && value.charAt(value.length - 5) === "D") {
          // Remove first 3 characters and last 5 characters
          return value.slice(3, -5);
        }
        return value;
      });

    setShipmentDetails((prevDetails) => [...prevDetails, ...scannedBarcodes]);
  };

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };

  const [scaninfo, setScaninfo] = useState({
    billedDate: "",
  });

  console.log("scan:", scaninfo);
  const [msg, setMsg] = useState();
  const [errorMsg, setError] = useState();
  function UpdateSettlement() {
    if (scaninfo.cx_settled_date) {
      setError("");
      setMsg("");
      const payload = {
        updatedBy: sessionStorage.getItem("userid"),
        billedDate: scaninfo.cx_settled_date,
        updated_date: new Date().toISOString().split("T")[0],
        jobIds: shipmentDetails,
      };

      console.log("payload is", payload);
      setMsg("Processing...");
      setMsg("Processing...");

      axios
        .post(`${API_URL}shypvdriverapp/admin/update-is-billed`, payload)
        .then((response) => {
          console.log("Response:", response.data);

          let errorMessages = [];

          if (response.data.success) {
            setMsg(response.data.data); // Show "1 orders updated to SETTLED"
            return;
          }

          if (response.data.errors && response.data.errors.length > 0) {
            response.data.errors.forEach((err) => {
              if (Array.isArray(err.errorDetails)) {
                err.errorDetails.forEach((detail) => {
                  errorMessages.push(`${detail}`);
                });
              } else {
                errorMessages.push(`${err.errorDetails || err.errorMessage}`);
              }
            });

            // Show all error messages as a string
            setMsg(errorMessages.join("\n"));
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setMsg("An error occurred while dispatching orders.");
        });
    } else {
      setError("Please enter all the required fields");
    }
  }

  const handleDelete = (awbToDelete) => {
    // Filter out the AWB to delete
    const updatedDetails = shipmentDetails.filter((awb) => awb !== awbToDelete);
    setShipmentDetails(updatedDetails);
    setMsg("");
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the uploaded file directly
    if (file) {
      bulkUpload(file); // Pass file directly to bulkUpload
    }
  };

  const bulkUpload = (file) => {
    console.log("called");
    if (file) {
      console.log("called2");
      const reader = new FileReader();

      reader.onload = function (e) {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rawJson = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
          raw: true,
        });

        const processedJson = rawJson.map((row) => {
          const newRow = {};
          Object.entries(row).forEach(([key, value]) => {
            newRow[key] = value;
          });
          return newRow;
        });

        console.log("Parsed Excel Data with Formatted Dates:", processedJson);

        // Assuming each "awb" in the parsed JSON contains an "AWB" key
        const awbValues = processedJson.map((awb) => awb.AWB).filter(Boolean);

        // Add the AWB values to shipmentDetails (similar to processBarcode behavior)
        setShipmentDetails((prevDetails) => [...prevDetails, ...awbValues]);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  return (
    <div>
      <div className="form-container">
        <div className="row">
          <div className="col-md-6">
            <h5 style={{ float: "left" }}>Billing Update</h5>
          </div>
          <div className="col-md-6">
            <a
              href="/bulk_template/cx_update.csv"
              download="billing_update.csv"
              className="panel-title my-wallet-rec buttonstyle"
            >
              Download Template
            </a>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Settled on</label>
              <input
                type="date"
                value={scaninfo.cx_settled_date}
                onChange={(e) =>
                  setScaninfo({ ...scaninfo, cx_settled_date: e.target.value })
                }
              />
            </div>

            {/* Barcode Input */}

            <div className="form-group">
              <label htmlFor="time">AWB File:</label>
              <input type="file" id="task_file" onChange={handleFileChange} />
            </div>

            <hr></hr>
            <p>OR</p>

            <div className="form-group">
              <label htmlFor="driver">AWB:</label>

              <textarea
                id="driver"
                value={barcode}
                onChange={handleBarcodeInputChange}
                // onKeyUp={handleBarcodeKeyUp}
                onKeyDown={handleBarcodeKeyDown}
                placeholder="Scan barcode and press Enter"
                autoFocus
                style={{ minHeight: "120px", width: "100%" }}
              />
            </div>
          </div>
          <div className="col-md-5">
            {loading && <p>Loading shipment details...</p>}

            {shipmentDetails.length > 0 && (
              <div>
                <h3>Shipment Details:</h3>
                <div
                  className="shipdata"
                  style={{
                    background: "#5583af59",
                    maxHeight: "400px", // Adjust the height limit as needed
                    overflowY: "auto", // Enables vertical scrolling
                    padding: "10px", // Optional: Add some padding for better visuals
                    border: "1px solid #ccc", // Optional: Add a border for separation
                  }}
                >
                  {shipmentDetails.map((awb, index) => (
                    //        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    //       <p key={index} style={{ textAlign: 'left', marginRight: '10px', marginBottom: '0' }}>{awb}</p>
                    //       <a
                    //   style={{ color: 'red', cursor: 'pointer', marginLeft: '10px' }}
                    //   onClick={() => handleDelete(awb)} // Delete this AWB when clicked
                    // >
                    //   <i className="fa fa-trash" />
                    // </a>
                    // </div>

                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    >
                      <p
                        style={{
                          textAlign: "left",
                          marginRight: "10px",
                          marginBottom: "0",
                          flex: 1, // Ensures <p> takes up remaining space
                          overflow: "hidden", // To handle long text gracefully
                          textOverflow: "ellipsis", // To truncate overflowed text with "..."
                        }}
                      >
                        {awb}
                      </p>
                      <a
                        style={{
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "10px",
                          flexShrink: 0, // Prevent the delete icon from shrinking
                        }}
                        onClick={() => handleDelete(awb)} // Delete this AWB when clicked
                      >
                        <i className="fa fa-trash" />
                      </a>
                    </div>
                  ))}
                </div>

                <a
                  onClick={UpdateSettlement}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Submit
                </a>
                {msg && <pre style={{ marginTop: "5%" }}>{msg}</pre>}
              </div>
            )}
          </div>
        </div>
        <p style={{ color: "red" }}>{errorMsg}</p>
      </div>
    </div>
  );
};

export default BillingUpdate;
